import * as React from "react";

import { InputAdornment, LinearProgress } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

import AppBar from "@material-ui/core/AppBar";
import Backdrop from "@material-ui/core/Backdrop";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import { CorrectByListAPI } from "../../Common/api";
import { ErrorMessages } from "../../Common/error";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import { TextLimits } from "../../Common/limits";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { compareListName } from "../../Common/sortUtils";
import dic from "../../Images/dic.png";
import garbage from "../../Images/garbage.png";
import { getPermissions } from "../../Common/permissions";
// icons
import glass from "../../Images/glass.png";
import reload from "../../Images/reload.png";
import { useAuth0 } from "@auth0/auth0-react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    body_header: {
      flexGrow: 1,
      zIndex: 1,
      backgroundColor: "rgba(0,0,0,0)",
    },
    router_link: {
      margin: "10px",
    },
    toolbar: {
      padding: 0,
      minHeight: 48,
      marginTop: 10,
      marginBottom: 10,
    },
    title: {
      flexGrow: 1,
      color: "#002081",
    },
    searchBoxBar: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "40px",
    },
    searchBox: {
      width: "478px",
      marginRight: "150px",
    },
    glassImage: {
      width: "24px",
      height: "23px",
    },
    dicImage: {
      width: "21px",
      height: "30px",
      marginRight: "15px",
    },
    reloadDeleteButton: {
      paddingLeft: "10px",
      paddingRight: "10px",
      minWidth: 0,
    },
    reloadImage: {
      width: "23px",
      height: "23px",
    },
    garbageImage: {
      width: "20",
      height: "23px",
    },
    table_body: {
      textAlign: "center",
      borderWidth: 0,
      borderRightWidth: "1px",
      borderBottomWidth: "1px",
      borderColor: "#D0D0D0",
      borderStyle: "solid",
      paddingTop: "20px",
      paddingBottom: "20px",
    },
    table: {
      borderWidth: 0,
      borderLeftWidth: "1px",
      borderTopWidth: "1px",
      borderColor: "#D0D0D0",
      borderStyle: "solid",
      marginBottom: "30px",
    },
    tableHeader: {
      backgroundColor: "#C4EDFF",
      paddingTop: "20px",
      paddingBottom: "20px",
      borderWidth: 0,
      borderRightWidth: "1px",
      borderBottomWidth: "1px",
      borderColor: "#D0D0D0",
      borderStyle: "solid",
      textAlign: "center",
    },
    textContainer: {
      display: "block",
      whiteSpace: "normal",
      wordWrap: "break-word",
    },
    checkbox: {
      padding: 0,
      borderRadius: 0,
      backgroundColor: "white",
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
  })
);
export default function DictionaryList() {
  const style = useStyles();

  const [checkedIDs, setCheckedIDs] = React.useState([]);
  const [checkBoxStatus, setCheckBoxStatus] = React.useState({});
  const [rawRows, setRawRows] = React.useState(null);
  const [allChecked, setAllChecked] = React.useState(false);

  const [backDropping, setBackDropping] = React.useState(false);

  const [reloadListTrigger, reloadList] = React.useState(false);
  const [searchText, setSearchText] = React.useState("");
  const handleSearchBoxChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleCheckboxChange = (event, id) => {
    if (id === "checkAll") {
      setAllChecked(event.target.checked);
      for (const key of Object.keys(checkBoxStatus)) {
        checkBoxStatus[key] = event.target.checked;
        setCheckBoxStatus(checkBoxStatus);
      }
    } else {
      checkBoxStatus[id] = event.target.checked;
      setCheckBoxStatus(checkBoxStatus);
      const allChecked = Object.values(checkBoxStatus).every((elm) => elm);
      setAllChecked(allChecked);
    }
    const _checkedIDs = [];
    for (const key of Object.keys(checkBoxStatus)) {
      if (checkBoxStatus[key]) _checkedIDs.push(key);
    }
    setCheckedIDs(_checkedIDs);
  };

  // TODO 未選択とか複数選択チェックとか
  const getFirstCheckedID = () => {
    return checkedIDs[0];
  };

  return (
    <React.Fragment>
      <Backdrop className={style.backdrop} open={backDropping}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <BodyHeader
        getFirstCheckedID={getFirstCheckedID}
        checkedIDs={checkedIDs}
        reloadList={reloadList}
        setBackDropping={setBackDropping}
      />
      <SearchBox
        handleSearchBoxChange={handleSearchBoxChange}
        checkedIDs={checkedIDs}
        rawRows={rawRows}
        reloadList={reloadList}
        setBackDropping={setBackDropping}
      />
      <DictionaryListTable
        rawRows={rawRows}
        setRawRows={setRawRows}
        searchText={searchText}
        handleChange={handleCheckboxChange}
        allChecked={allChecked}
        setCheckedIDs={setCheckedIDs}
        setAllChecked={setAllChecked}
        checkBoxStatus={checkBoxStatus}
        setCheckBoxStatus={setCheckBoxStatus}
        reloadListTrigger={reloadListTrigger}
        setBackDropping={setBackDropping}
      />
    </React.Fragment>
  );
}

function BodyHeader(props) {
  const style = useStyles();
  console.log(props);
  return (
    <AppBar
      className={style.body_header}
      position="static"
      color="default"
      elevation={0}
    >
      <Toolbar className={style.toolbar}>
        <Typography variant="h6" className={style.title}>
          単語辞書一覧
        </Typography>
      </Toolbar>
    </AppBar>
  );
}

function SearchBox(props) {
  const style = useStyles();
  const history = useHistory();
  const { getAccessTokenSilently, getIdTokenClaims } = useAuth0();
  return (
    <div className={style.searchBoxBar}>
      <TextField
        id="outlined-basic"
        label="検索する"
        size="small"
        fullWidth
        autoComplete="off"
        onChange={props.handleSearchBoxChange}
        className={style.searchBox}
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <img src={glass} className={style.glassImage} alt="search" />
            </InputAdornment>
          ),
        }}
        inputProps={{
          maxLength: TextLimits.MAX_TEXT_LENGTH,
        }}
      />
      <Button
        variant="contained"
        onClick={() => history.push("/dictionary/upload")}
        disabled={!getPermissions().create.dictionary}
      >
        <img
          src={dic}
          className={style.dicImage}
          alt="newTemplate"
          style={!getPermissions().create.dictionary ? { opacity: 0.2 } : {}}
        />
        新しい単語辞書を作成する
      </Button>
      <Button
        className={style.reloadDeleteButton}
        title="再読込"
        variant="contained"
        onClick={() => {
          props.setBackDropping(true);
          props.reloadList((current_value: boolean) => !current_value);
        }}
        disabled={!getPermissions().list.dictionary}
      >
        <img
          src={reload}
          className={style.reloadImage}
          alt="reload"
          style={!getPermissions().list.dictionary ? { opacity: 0.2 } : {}}
        />
      </Button>
      <Button
        className={style.reloadDeleteButton}
        title="削除する"
        variant="contained"
        disabled={!getPermissions().delete.dictionary}
        onClick={() => {
          if (props.checkedIDs.length === 0) {
          } else if (window.confirm("選択した辞書を削除しますか？")) {
            props.setBackDropping(true);
            deleteDictionaries(
              props.checkedIDs,
              props.rawRows,
              props.reloadList,
              getAccessTokenSilently,
              getIdTokenClaims
            );
          }
        }}
      >
        <img
          src={garbage}
          className={style.garbageImage}
          alt="delete"
          style={!getPermissions().delete.dictionary ? { opacity: 0.2 } : {}}
        />
      </Button>
    </div>
  );
}

function DictionaryListTable(props) {
  const { getAccessTokenSilently, getIdTokenClaims } = useAuth0();
  const style = useStyles();
  const history = useHistory();
  const [rows, setRows] = React.useState(null);

  const checkboxCol = { maxWidth: "48px", minWidth: "48px", padding: 0 };
  const editButtonCol = { maxWidth: "110px", minWidth: "110px" };

  const reloadListTrigger = props.reloadListTrigger;
  const searchText = props.searchText;
  const setCheckBoxStatus = props.setCheckBoxStatus;
  const setBackDropping = props.setBackDropping;
  const setRawRows = props.setRawRows;
  const setCheckedIDs = props.setCheckedIDs;
  const setAllChecked = props.setAllChecked;
  React.useEffect(() => {
    const listOfListsGetter = new CorrectByListAPI("get_list_of_lists");
    listOfListsGetter.setParam({ param: {} });
    getAccessTokenSilently()
      .then(() => getIdTokenClaims())
      .then((idToken) => {
        listOfListsGetter
          .execPostRequest(idToken.__raw)
          .then((response) => response.json())
          .then(
            (res) => {
              console.log("getListOfListsRes", res);
              let sortedRows = res.result.list_of_lists.sort(compareListName);
              setRawRows(sortedRows);
              setRows(sortedRows);
              const initialCheckBoxStatus = {};
              for (const row of sortedRows) {
                initialCheckBoxStatus[row.list_id] = false;
              }
              setCheckBoxStatus(initialCheckBoxStatus);
              setCheckedIDs([]);
              setAllChecked(false);
              setBackDropping(false);
            },
            (error) => {
              console.log(error);
            }
          );
      });
  }, [
    setRawRows,
    reloadListTrigger,
    setCheckBoxStatus,
    setBackDropping,
    getAccessTokenSilently,
    getIdTokenClaims,
    setAllChecked,
    setCheckedIDs,
  ]);

  const rawRows = props.rawRows;
  React.useEffect(() => {
    if (searchText !== "") {
      const searchWords = searchText.split(/\s+/);
      const hitRowIDs = [];

      // name, description, template_id, ocr_result_binder_id
      // のいずれかにすべてのwordが含まれるかチェック
      for (const row of rawRows) {
        const hitWords = [];
        for (const word of searchWords) {
          const lowerWord = word.toLowerCase();
          if (
            row.list_name.toLowerCase().includes(lowerWord) ||
            row.list_id.toLowerCase().includes(lowerWord)
          ) {
            hitWords.push(word);
          } else {
            break;
          }
        }
        if (searchWords.every((word) => hitWords.includes(word))) {
          hitRowIDs.push(row.list_id);
        }
      }
      const sortedRows = rawRows.filter((row) =>
        hitRowIDs.includes(row.list_id)
      );
      setRows(sortedRows);
      const initialCheckBoxStatus = {};
      for (const row of sortedRows) {
        initialCheckBoxStatus[row.list_id] = false;
      }
      setCheckBoxStatus(initialCheckBoxStatus);
      setCheckedIDs([]);
      setAllChecked(false);
    } else {
      if (rawRows) {
        setRows(rawRows);
        const initialCheckBoxStatus = {};
        for (const row of rawRows) {
          initialCheckBoxStatus[row.list_id] = false;
        }
        setCheckBoxStatus(initialCheckBoxStatus);
        setCheckedIDs([]);
        setAllChecked(false);
      }
    }
  }, [
    reloadListTrigger,
    rawRows,
    searchText,
    setCheckBoxStatus,
    setAllChecked,
    setCheckedIDs,
  ]);

  return rows === null ? (
    <React.Fragment>
      <LinearProgress />
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Table
        className={style.table}
        size="small"
        aria-label="a dense table"
        stickyHeader
      >
        <TableHead>
          <TableRow>
            <TableCell className={style.tableHeader} style={checkboxCol}>
              <Checkbox
                className={style.checkbox}
                size="small"
                disableRipple
                checked={props.allChecked}
                onChange={(event) => {
                  props.handleChange(event, "checkAll");
                }}
              />
            </TableCell>
            <TableCell className={style.tableHeader}>辞書名</TableCell>
            <TableCell className={style.tableHeader}>辞書ID</TableCell>
            <TableCell className={style.tableHeader}>編集する</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={row.list_id}
              id={row.list_id}
              style={
                index % 2
                  ? { backgroundColor: "#f2f2f2" }
                  : { backgroundColor: "white" }
              }
            >
              <TableCell className={style.table_body} style={checkboxCol}>
                <Checkbox
                  className={style.checkbox}
                  size="small"
                  disableRipple
                  checked={props.checkBoxStatus[row.list_id] === true}
                  onChange={(event) => {
                    props.handleChange(event, row.list_id);
                  }}
                />
              </TableCell>
              <TableCell
                className={style.table_body}
                component="th"
                scope="row"
              >
                {getPermissions().read.dictionary ? (
                  <Link to={"/dictionary/edit?list_id=" + row.list_id}>
                    <div className={style.textContainer}>{row.list_name}</div>
                  </Link>
                ) : (
                  <div className={style.textContainer}>{row.list_name}</div>
                )}
              </TableCell>
              <TableCell className={style.table_body}>
                <div className={style.textContainer}>{row.list_id}</div>
              </TableCell>
              <TableCell className={style.table_body} style={editButtonCol}>
                <Button
                  variant="contained"
                  onClick={() => {
                    history.push("/dictionary/edit?list_id=" + row.list_id);
                  }}
                  disabled={!getPermissions().read.dictionary}
                >
                  編集
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </React.Fragment>
  );
}

const deleteDictionaries = (
  list_IDs,
  rawRows,
  reloadList,
  getAccessTokenSilently,
  getIdTokenClaims
) => {
  getAccessTokenSilently()
    .then(() => getIdTokenClaims())
    .then((idToken) => {
      let promises = [];
      list_IDs.map((list_id) => {
        const listDeleter = new CorrectByListAPI("delete_list");
        const listDeleteParam = {
          param: { list_id: list_id },
          binary_data: {},
        };
        listDeleter.setParam(listDeleteParam);
        promises.push(
          listDeleter
            .execPostRequest(idToken.__raw)
            .then((response) => response.json())
            .then((deleteDictionaryResult) => {
              if (deleteDictionaryResult.ocrapi_status.code === 31111) {
                for (const row of rawRows) {
                  if (row.list_id === list_id) {
                    alert(
                      "選択された辞書は使用されているため削除できません。\n" +
                        `辞書名：${row.list_name}\n` +
                        `辞書ID：${row.list_id}`
                    );
                  }
                }
              }
              return deleteDictionaryResult;
            })
        );
        return [];
      });

      Promise.all(promises).then(
        (results) => {
          console.log("deleteRes", results);
          reloadList((current_value: boolean) => !current_value);
        },
        (error) => {
          console.log("ERROR", error);
          alert(ErrorMessages.pleaseTryAgain);
          reloadList((current_value: boolean) => !current_value);
        }
      );
    });
};
